import { ACTIVATE_HOOK, DEACTIVATE_HOOK, REGISTER_HOOK, UPDATE_HOOK } from '../../mutation-types';


export function activateHook({ commit }, { id }) {
    commit(ACTIVATE_HOOK, { id });
}

export function deactivateHook({ commit }, { id }) {
    commit(DEACTIVATE_HOOK, { id });
}

export function registerHook({ commit }, {
    offset,
    id,
    rotation,
    position,
}) {
    commit(REGISTER_HOOK, {
        offset,
        id,
        rotation,
        position,
    });
}

export function updateHook({ commit }, { id, offset, rotation, position }) {
    commit(UPDATE_HOOK, { id, offset, rotation, position });
}
